import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PostUser(user, modifiedBy, environment) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}user`;

    let rol = null;

    rol = user.rol === "si" ?  rol = "7136f7c7-f668-457b-b143-ddc816a4679d" : null;
  
    const userPost = {
        name : user.name,
        surname : user.surname,
        nif: user.nif ? user.nif : null,
        rol : rol,
        mail : user.mail,
        environment: environment,
        modifiedBy: modifiedBy
    }

    const response = await axios.post(req, userPost, apiConfig.HEADERS_CONFIG,{
      });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
